import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Message, Text } from '@marvelapp/ui';
export default function InputError(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(Message, Object.assign({ kind: "error", mt: 3 }, props, { children: _jsx(Text, { fontSize: 2, children: children }) })));
}
